<template>
  <div class="form-wrapper">
    <h2>Budget & schedule</h2>

    <div class="form-group switch">
      <label>Budget <span class="required">*</span></label>
    </div>

    <div class="platform-budgets">
      <div
        class="platform-card"
        v-for="(platform, index) in platforms"
        :key="platform.name"
        :class="{ blurred: platform.name === 'Meta' && store.disableMeta }"
      >
        <div class="platform-header">
          <img :src="platform.icon" class="icon" />
          {{ platform.name }}
        </div>

        <div class="radio-options justify-space-between">
          <span>
            <input
              type="radio"
              :name="'budgetType_' + index"
              value="daily"
              v-model="platform.budgetType"
            />
            Daily
          </span>
          <span>
            <input
              type="radio"
              :name="'budgetType_' + index"
              value="lifetime"
              v-model="platform.budgetType"
            />
            Life time
          </span>
        </div>

        <input type="text" v-model="platform.amount" placeholder="" />
        <div class="currency">{{ platform.currency }}</div>
      </div>
    </div>

    <div class="form-group">
      <label>Start date <span class="required">*</span></label>
      <input type="date" v-model="startDate" />
    </div>

    <div class="form-group">
      <label>End date</label>
      <input type="date" v-model="endDate" />
    </div>
  </div>
</template>

<script>
import { useSuperAddStore } from "@/store/superAddStore";
export default {
  name: "BudgetScheduleForm",
  props: {
    initialPlatforms: Array,
    initialAutoBudget: Boolean,
    initialStartDate: String,
    initialEndDate: String,
    disableMeta: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      autoBudget: this.initialAutoBudget ?? true,
      startDate: this.initialStartDate || "",
      endDate: this.initialEndDate || "",
      store: useSuperAddStore(),
    };
  },
  computed: {
    platforms() {
      return this.store.platforms;
    },
  },
  methods: {
    getData() {
      return {
        autoBudget: this.autoBudget,
        startDate: this.startDate,
        endDate: this.endDate,
        budgets: this.platforms.map((p) => ({
          name: p.name,
          amount: p.amount,
          currency: p.currency,
          budgetType: p.budgetType,
        })),
      };
    },
    validate() {
      const errors = [];

      const hasInvalidBudgets = this.platforms.some((p) => {
        if (p.name === "Meta" && this.store.disableMeta) {
          return false; // ✅ تجاهل التحقق على Meta لو كانت disabled
        }

        const val = Number(p.amount);
        return !p.amount || isNaN(val) || val <= 0;
      });

      if (hasInvalidBudgets) {
        errors.push("Each platform must have a valid budget amount.");
      }

      if (!this.startDate) {
        errors.push("Start date is required.");
      }

      if (this.endDate && this.startDate && this.endDate < this.startDate) {
        errors.push("End date must be after start date.");
      }

      return errors.length ? errors : null;
    },
  },
  mounted() {
    this.platforms.forEach((platform) => {
      if (!platform.budgetType) {
        this.$set(platform, "budgetType", "daily");
      }
    });
  },
};
</script>

<style scoped>
.form-wrapper {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin: auto;
}

h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

label {
  font-weight: 500;
  min-width: 14rem;
}
.tit {
  min-width: auto !important;
}

input[type="text"],
input[type="date"] {
  padding: 0.6rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  flex: 1;
  width: 100%;
}

.required {
  color: red;
}

.switch {
  align-items: center;
}

.toggle-label {
  width: 40px;
  height: 22px;
  background: #ccc;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
  min-width: auto;
}
.disabled-card {
  border: 1px dashed #aaa;
  background-color: #f7f7f7;
}
input[type="checkbox"] {
  display: none;
}

input[type="checkbox"]:checked + .toggle-label {
  background: #237276;
}
input[type="radio"] {
  accent-color: #207878;
}

.toggle-label .circle {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 2px;
  left: 2px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s;
}

input[type="checkbox"]:checked + .toggle-label .circle {
  transform: translateX(18px);
}

.label-text {
  font-size: 0.9rem;
  color: #444;
}

.platform-budgets {
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
  flex-wrap: wrap;
}

.platform-card {
  border: 1px solid #eee;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  flex: 1;
  min-width: 200px;
  position: relative;
}

.platform-header {
  font-weight: bold;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  background: #f2f2f2;
  gap: 0.8rem;
  padding: 0.5rem;
  border-radius: 0.3rem;
}

.icon {
  width: 20px;
  height: 20px;
}

.radio-options {
  display: flex;
  gap: 1rem;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.currency {
  position: absolute;
  bottom: 1.7rem;
  right: 1.7rem;
  color: gray;
  font-size: 0.8rem;
}
.form-group.switch {
  display: flex;
  flex-direction: column; /* ✅ عمودي */
  align-items: flex-start;
  gap: 0.5rem;
  min-width: auto;
}

.switch-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.platform-card {
  position: relative;
}

.blurred {
  pointer-events: none;
  opacity: 0.6;
}

.platform-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(255 255 255 / 74%);
  backdrop-filter: none;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  border-radius: 10px;
  pointer-events: auto;
}

.overlay-message {
  color: #b02a37;
  font-weight: 600;
  font-size: 14px;
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #e0dcdc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  text-align: center;
  text-shadow: none; /* تأكد أنه واضح */
}
</style>
